export enum InfoLabelSize {
  small,
  default,
  large,
}
